export default "__VITE_ASSET__CvLtsiiK__"